import { Box } from "@mui/material";

const SectionContainer = ({ children, id, bgcolor, sx, ...rest }) => (
  <Box
    id={id}
    sx={{
      bgcolor,
      py: { xs: 6, md: 10 },
      px: { xs: 3, md: 5 },
      maxWidth: 1200,
      mx: "auto",
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Box>
);

export default SectionContainer;
